const hanhDongChinhSua = {
  khong: 0,
  trinhDuyet: 1,
  choDuyet: 2,
  dongY: 3,
  daSua: 4,
}
const mapHanhDong = (hanhDong, data) => {
  switch (hanhDong) {
    case hanhDongChinhSua.trinhDuyet:
      return data.noiDung ? 'Không đồng ý chỉnh sửa' : 'Gửi yêu cầu chỉnh sửa'
    case hanhDongChinhSua.choDuyet:
      return 'Gửi yêu cầu chờ duyệt'
    case hanhDongChinhSua.dongY:
      return 'Đồng ý'
    case hanhDongChinhSua.daSua:
      return 'Đã sửa'
    case hanhDongChinhSua.khong:
      return 'Huỷ chỉnh sửa'
    default:
      return ''
  }
}
export default hanhDongChinhSua
export { mapHanhDong }
